<template>
  <div>
    <van-tabbar id="footer" v-show="true">
      <van-tabbar-item :to="{path:'/kpi',query: { act_id: act_id}}">
        <i :class="this.$route.path==='/kpi' ? 'icon-kpi-home-on' : 'icon-kpi-home'"></i>
        <p :class="this.$route.path==='/kpi'?'active':'grey'" style="margin-bottom:0">首页</p>
      </van-tabbar-item>
      <van-tabbar-item :to="{path:'/kpi/achieve',query: { act_id: act_id}}">
        <i :class="this.$route.path==='/kpi/achieve' ? 'icon-kpi-achieve-on' : 'icon-kpi-achieve'"></i>
        <p :class="this.$route.path==='/kpi/achieve'?'active':'grey'" style="margin-bottom:0">业绩</p>
      </van-tabbar-item>
      <van-tabbar-item :to="{path:'/kpi/rank',query: { act_id: act_id}}">
        <i :class="this.$route.path==='/kpi/rank' ? 'icon-kpi-rank-on' : 'icon-kpi-rank'"></i>
        <p :class="this.$route.path==='/kpi/rank'?'active':'grey'" style="margin-bottom:0">排行</p>
      </van-tabbar-item>
      <van-tabbar-item :to="{path:'/kpi/finance',query: { act_id: act_id}}">
        <i :class="this.$route.path==='/kpi/finance' ? 'icon-kpi-finance-on' : 'icon-kpi-finance'"></i>
        <p :class="this.$route.path==='/kpi/finance'?'active':'grey'" style="margin-bottom:0">财务</p>
      </van-tabbar-item>
      <!--<van-tabbar-item :to="{ name: 'kpi.info', query: { activity_id: activity.id}}">-->
      <!--<van-tabbar-item :to="{ name: '', query: { activity_id: activity.id}}" @click="info">-->
      <!--<i :class="this.$route.path==='/kpi/info' ? 'icon-kpi-info-on' : 'icon-kpi-info'"></i>-->
      <!--<p :class="this.$route.path==='/kpi/info'?'active':'grey'">信息</p>-->
      <!--</van-tabbar-item>-->
    </van-tabbar>
  </div>
</template>

<script>
export default {
  data(){
    return{
      act_id: localStorage.getItem("act_id"),
    }
  }
};
</script>

<style lang="less" scoped>
.van-tabbar {
  .van-tabbar-item {
    height: 50px;
    width: 25%;
    text-align: center;
    img {
      width: 22px;
      height: 22px;
    }
    p {
      /*文字与图片上下间隔*/
      margin-top: 5px;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
    }
  }
  .active {
    color: #5293fd !important;
  }
  .grey {
    color: #999999 !important;
  }
  i {
    display: block;
    position: relative;
    width: 22px;
    height: 22px;
    margin: 0 auto;
  }
  .icon-kpi-home-on {
    background: url(https://j.weizan.cn/youxiang/images/kpi-tabbar.png) no-repeat -10px -39px;
    background-size: 220px 70px;
  }
  .icon-kpi-home {
    background: url(https://j.weizan.cn/youxiang/images/kpi-tabbar.png) no-repeat -10px -4px;
    background-size: 220px 70px;
  }
  .icon-kpi-achieve-on {
    background: url(https://j.weizan.cn/youxiang/images/kpi-tabbar.png) no-repeat -52px -39px;
    background-size: 220px 70px;
  }
  .icon-kpi-achieve {
    background: url(https://j.weizan.cn/youxiang/images/kpi-tabbar.png) no-repeat -52px -4px;
    background-size: 220px 70px;
  }
  .icon-kpi-rank-on {
    background: url(https://j.weizan.cn/youxiang/images/kpi-tabbar.png) no-repeat -90px -38px;
    background-size: 210px 69px;
  }
  .icon-kpi-rank {
    background: url(https://j.weizan.cn/youxiang/images/kpi-tabbar.png) no-repeat -90px -4px;
    background-size: 210px 69px;
  }
  .icon-kpi-finance-on {
    background: url(https://j.weizan.cn/youxiang/images/kpi-tabbar.png) no-repeat -141px -39px;
    background-size: 220px 70px;
  }
  .icon-kpi-finance {
    background: url(https://j.weizan.cn/youxiang/images/kpi-tabbar.png) no-repeat -141px -4px;
    background-size: 220px 70px;
  }
  .icon-kpi-info-on {
    background: url(https://j.weizan.cn/youxiang/images/kpi-tabbar.png) no-repeat -185px -39px;
    background-size: 220px 70px;
  }
  .icon-kpi-info {
    background: url(https://j.weizan.cn/youxiang/images/kpi-tabbar.png) no-repeat -184px -4px;
    background-size: 220px 70px;
  }
}
</style>